module.exports = __webpack_public_path__ + "static/numbers-4-2-5a600bb0e2e6a8748d8ad033597d49bf.png";